import { FC, useEffect, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from 'recharts';
import { colors, STUDY_INSIGHTS_TRANSLATION } from '@modules/study-insights/constants';
import { SequenceGoalChartProps } from './SequenceGoalChart.types';
import { useTranslation } from 'react-i18next';

const SequenceGoalChart: FC<SequenceGoalChartProps> = ({ accentColor, color, data }) => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);
  const [activeIndex, setActiveIndex] = useState<number>();

  const CELL_COLORS = [colors.coolGray300, accentColor];

  useEffect(() => {
    setActiveIndex(1);
  }, []);

  /* tslint:disable */
  /** Recharts receive these props as any  */
  const renderActiveShape = (props: any): any => {
    const { cx, cy, cornerRadius, innerRadius, outerRadius, startAngle, endAngle, percent } = props;

    return (
      <g>
        <text
          data-testid="achieved-percentage-value"
          x={cx}
          y={parseInt(cy) - 10}
          dy={8}
          textAnchor="middle"
          fill={color ? color.text : colors.darkBlue200}
          fontSize="24px"
          fontWeight="620"
        >
          {/* eslint-disable-next-line */}
          {(percent * 100).toFixed(0)}%
        </text>
        <text
          x={cx}
          y={parseInt(cy) + 10}
          dy={8}
          textAnchor="middle"
          fill={colors.darkGray300}
          fontSize="12px"
          fontWeight="344"
        >
          {t('achieved')}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          cornerRadius={cornerRadius}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={color ? color.sector : colors.darkBlue200}
        />
      </g>
    );
  };
  /* tslint:enabled */

  return (
    <ResponsiveContainer aspect={1} maxHeight={106}>
      <PieChart>
        <Pie
          activeIndex={activeIndex}
          activeShape={renderActiveShape}
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius={43}
          outerRadius={53}
          startAngle={-270}
          endAngle={90}
        >
          {data.map((_entry: any, index: number) => (
            <Cell key={`cell-${index}`} fill={CELL_COLORS[index % CELL_COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default SequenceGoalChart;
